export default (error) => {
  return error.inner
    ? error.inner.reduce((errors, item) => {
        return { ...errors, [item.path]: item.message }
      }, {})
    : {}
}
